export class Address {

    public firstName: string;
    public lastName: string;
    public companyName: string;
    public street: string;
    public apartment: string;
    public postalCode: string;
    public regionCode: string;
    public city: string;
    public countryIsoCode: string = "es";
    public phone: string;
    public email: string;

}